import { AnyAction } from 'redux';
import {
    showInfoAsync,
    showNotificationAsync,
    showWarningAsync,
} from 'notification/store/thunks';
import { IndigoStore, ThunkDispatch } from 'store/store';
import { NotificationType } from '@instinet-analytics/semantic-ui-components';

export class NotificationService {
    public store: IndigoStore | undefined;

    public showNotification(
        message: string,
        type: NotificationType,
        title?: string
    ) {
        this.dispatch(showNotificationAsync(message, type, title));
    }

    public showWarning(message: string, title?: string) {
        this.dispatch(showWarningAsync(message, title));
    }

    public showInfo(message: string, title?: string) {
        this.dispatch(showInfoAsync(message, title));
    }

    private get dispatch(): ThunkDispatch<AnyAction> {
        if (!this.store) {
            throw new Error('store must be set');
        }
        return this.store!.dispatch;
    }
}
